import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export interface ICheckScoreResponse {
  score: number;
}

const checkScoreAPI = async (email: string): Promise<ICheckScoreResponse | boolean> => {
    try {
      const config: AxiosRequestConfig = {
        method: 'POST',
        // Lokalno (development)
        // url: `http://localhost:6002/api/ultra/politehnika/check-score-main`,
        
        // Produkcija
        url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/check-score-main`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: { email },
      };
  
      const response: AxiosResponse = await axios(config);
  
      // Izvlačimo rezultat iz `data.vrati_rezultat_main_politehnika`
      const { data } = response.data;
      const score = parseInt(data.vrati_rezultat_main_politehnika, 10);
  
      return { score };
    } catch (error) {
      console.error('Došlo je do greške pri pozivu check-score API-ja:', error);
      return false;
    }
  };
  

export default checkScoreAPI;
